import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Close/Remove Icon
// =============================================================================

export function WebsiteCloseX(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WebsiteCloseX",
    viewBox: "0 0 24 24",
    path: (
      <>
        <line
          x1="18"
          y1="6"
          x2="6"
          y2="18"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="6"
          y1="6"
          x2="18"
          y2="18"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
